import {FarmFeatures2Model} from '../../model/users/FarmFeatures2Model.js';
import {BaseCollection} from '../BaseCollection';
import {CountryUtils} from '../../utils/CountryUtils';

/**
 * @class FarmFeatures2Collection
 * @extends BaseCollection
 */
export class FarmFeatures2Collection extends BaseCollection {

    get model () {

        return FarmFeatures2Model;
    }

    initialize (models, options) {

        super.initialize(models, options);

        this.microservice = 'users';
        this.resource = 'v2/farm-features';
    }

    isTimingActiveForCrop (cropUuid) {

        return !!this.find({cropUuid, name: FarmFeatures2Model.NAME.TIMING});
    }

    isMappingActiveForCrop (cropUuid) {

        return !!this.find({cropUuid, name: FarmFeatures2Model.NAME.MAPPING});
    }

    checkIfMonitorFeatureExists () {

        let monitorFeature = this.find({name: 'MONITOR'});

        return !!monitorFeature;
    }

    checkIfNutritionFeatureExists () {

        let nutritionFeature = this.find({name: 'NUTRITION'});

        return !!nutritionFeature;
    }

    getFieldMonitorFarmFeature (country) {

        return new FarmFeatures2Model({
            farmUuid: undefined,
            cropUuid: undefined,
            name: 'MONITOR',
            validTill: CountryUtils.getFieldMonitorValidity(country),
            packageUuid: '7575b4c5-def2-467a-884a-e02b0d6194fd',
            packageType: 'FOC'
        }, {parse: true});
    }

    addFieldMonitorIfNotExists (country) {

        if (!this.checkIfMonitorFeatureExists()) {
            this.add(this.getFieldMonitorFarmFeature(country));
        }
    }

    getNutritionFarmFeature () {

        return new FarmFeatures2Model({
            farmUuid: undefined,
            cropUuid: undefined,
            name: 'NUTRITION',
            validTill: CountryUtils.getNutritionValidity(),
            packageUuid: '7575b4c5-def2-467a-884a-e02b0d4343fd',
            packageType: 'FOC'
        }, {parse: true});
    }

    addNutritionIfNotExists () {

        if (!this.checkIfNutritionFeatureExists()) {
            this.add(this.getNutritionFarmFeature());
        }
    }
}


// WEBPACK FOOTER //
// ./shared/collection/users/FarmFeatures2Collection.js